'use client';

// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-react/build/generate-icons

import { IconShareNodes, iconShareNodesTag } from '@ni/nimble-components/dist/esm/icons/share-nodes';
import { wrap } from '../../utilities/react-wrapper';

export type { IconShareNodes };
export { iconShareNodesTag };
export const NimbleIconShareNodes = wrap(IconShareNodes);